<template>
  <div class="oneui">
    <div></div>
    <div>
      <ul class="nameWrapper" :style="`grid-template-columns: 1fr;`">
        <li></li>
        <li class="current">
          <span>{{$t('pages.settings.headerText')}}</span>
        </li>
        <li></li>
      </ul>
    </div>
    <div class="pageWrapper">
      <div class="page">
        <div class="ul">
          <div class="li hide-on-watch" @click="toggleSlimView()">
            <span>{{$t('pages.settings.slimView')}}</span>
            <div :class="slimView ? 'fhr fhr-circle-check' : 'fhr fhr-circle'"></div>
          </div>
          <SettingsButton path="/settings/account" text="pages.settings.account" />
          <SettingsButton path="/settings/themes" text="pages.settings.themes" />
          <SettingsButton path="/settings/legal" text="pages.settings.legal" />
          <SettingsButton path="/settings/accessibility" text="pages.settings.accessibility" />
          <a @click="reportIssue()">
            <SettingsButton text="pages.settings.report" />
          </a>
          <a @click="share()">
            <SettingsButton text="Share App" />
          </a>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import SettingsButton from "../../components/SettingButton";
export default {
  components: { SettingsButton },
  data() {
    return {
      slimView: false
    };
  },
  mounted() {
    this.$data.slimView = this.$root.$data.parent.get("slimView");
  },
  methods: {
    share() {
      if (!navigator.userAgent.includes("AndroidApp")) {
        try {
          const shareData = {
            title: "Chore Champion",
            text: "Motivate your kids to do their chores!",
            url: "https://chore.cc"
          };
          navigator.share(shareData);
          gtag("event", "share");
        } catch {
          ModernModals.alert("Not Available on your platform.");
        }
      } else {
        gtag("event", "share");
        window.location.href = "chore://share";
      }
    },
    reportIssue() {
      window.location.href = "mailto:me@juliancruzsanchez.com?subject=Sugestions for Chore Champion"
    },
    toggleSlimView() {
      this.$data.slimView = !this.$data.slimView;
      this.$root.parent.set("slimView", this.$data.slimView);
      this.$root.parent.save();
    }
  }
};
</script>